
import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const reviews = [
  {
    author: "Axelle",
    date: "Mariage - Juillet 2025",
    text: "L'ambiance assurée ! Un grand merci à Issa qui a su nous accompagner des la signature du contrat jusqu'au jour j ! Ambiance garantie jusqu'au bout de la nuit ! La piste était endiablée et nos invités ne se sont pas ennuyés de la soirée ! Et qu'en a nous les mariés, nous avons adoré sa prestation ! Encore merci",
    rating: 5
  },
  {
    author: "Jean-Baptiste",
    date: "Évènement Entreprise - Mai 2025",
    text: "Professionnel, à l'écoute et très réactif. DJ Saff a transformé notre soirée corporate en un moment mémorable. Sa sélection musicale était parfaite.",
    rating: 5
  },
  {
    author: "Cécilia",
    date: "Anniversaire - Aout 2023",
    text: "Merci, c’était incroyable ! Issa est très professionnel et organisé ! Nous lui avons fait entièrement confiance pour la musique et l’animation de notre mariage.Il y avait tout le temps du monde sur la piste de danse.Il a su s’adapter aux différents moments(jeux / repas / séance photo / apéro ect ect )  Il nous a conseillé sur les musiques et timing. Vraiment incroyable!! Je recommande les yeux fermés. Ps : Issa est passionné et cela se ressent. Encore merci!",
    rating: 5
  },
  {
    author: "Joy",
    date: "Mariage - Août 2025",
    text: "L'ambiance assurée ! Un grand merci à Issa qui a su nous accompagner des la signature du contrat jusqu'au jour j !Professionnel et ambiance garantieNous avons eu la chance d’avoir Issa pour notre mariage, et c’était parfait du début à la fin! Très professionnel, à l’écoute de nos envies, il a su faire danser tout le monde tout au long de la soirée, la playlist était variée, et parfaitement adaptée aux moments clés de la soirée.Grâce à lui, l’ambiance a été au rendez - vous jusqu’au bout de la nuit. Il a également sonoriser la cérémonie laïque et c’était vraiment parfait, j’ai déjà été dans d’autres mariages où l’on entendait rien pendant les vœux… donc là vraiment c’était top. Nous le recommandons les yeux fermés!",
    rating: 5
  },
  {
    author: "Manon",
    date: "Mariage - Août 2025",
    text: "réactif et professionnel ! Je recommande à 100%, nous avons rencontré quelqu'un passionné par son métier. Nous avons fait des modifications de dernière minutes mais cela ne la pas déranger il a toujours était à notre écoute. Grâce à Issa nous avons passé une super journée et soirée même si on aurait voulu danser jusqu'au bout de la nuit. Professionnel, à l'écoute, réactif, confiance, voila qui est DJ SAFF.",
    rating: 5
  },
  {
    author: "Olivier",
    date: "Mariage - Juillet 2024",
    text: "Magnifique prestation pour un mariage international. Merci beaucoup pour votre professionnalisme, votre écoute et la qualité de la prestation. Vous avez su mixer sur différents répertoires pour un mariage avec des personnes venant de France, Qatar, Angola et Vietnam.Une belle et folle soirée de mariage grâce à vous. Par rapport à d'autres DJ, vous n'avez pas été fermé à nos envies et à nos demandes particulières. Merci encore !! Nous recommandons sans hésitation!!!",
    rating: 5
  },
   {
    author: "Hermine",
    date: "Mariage - Avril 2024",
    text: "Inoubliable ! Nous avons eu le plaisir d'engager Issa pour notre mariage, et nous ne pourrions pas être plus satisfaits de notre choix ! Dès le premier contact, il a su se montrer professionnel, à l'écoute de nos envies et de nos besoins. Le jour J, il a parfaitement su créer une ambiance festive et chaleureuse, en adaptant la musique à nos goûts et à ceux de nos invités.Les transitions entre les morceaux étaient fluides, et il a su lire la salle pour maintenir l'énergie sur la piste de danse. Nos invités n'ont pas arrêté de nous complimenter sur la musique et l'animation tout au long de la soirée.Grâce à DJ SAFF, notre mariage a été un véritable succès, et nous avons des souvenirs inoubliables. Nous le recommandons vivement à tous ceux qui cherchent un DJ talentueux et passionné pour leur événement.Merci encore Issa !",
    rating: 5
  },
  
  {
    author: "Oumou",
    date: "Soirée d'anniversaire - été 2019",
    text: "Je recommande vivement Issa, il est passionné et sait comment s y prendre pour régaler les gens ! Ambiance au top garantie ",
    rating: 5
  },
  {
    author: "Bruno AHP",
    date: "Fête de la musique - juin 2020",
    text: "bref, au top ! A recommander pour tout type musical.",
    rating: 5
  }
];

const Testimonials: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollTo = direction === 'left' ? scrollLeft - clientWidth / 1.5 : scrollLeft + clientWidth / 1.5;
      scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  return (
    <section id="reviews" className="py-24 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          <div className="space-y-4">
            <motion.span 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              className="text-gold text-xs font-bold tracking-[0.4em] uppercase"
            >
              Témoignages
            </motion.span>
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-4xl md:text-6xl font-serif font-bold"
            >
              Ils me font <span className="text-gold-gradient italic">Confiance</span>
            </motion.h2>
          </div>
          
          <div className="flex space-x-4">
            <button 
              onClick={() => scroll('left')}
              className="w-12 h-12 rounded-full glass flex items-center justify-center text-gold hover:bg-gold hover:text-dark transition-all border-white/10"
              aria-label="Précédent"
            >
              <ChevronLeft size={24} />
            </button>
            <button 
              onClick={() => scroll('right')}
              className="w-12 h-12 rounded-full glass flex items-center justify-center text-gold hover:bg-gold hover:text-dark transition-all border-white/10"
              aria-label="Suivant"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>

        {/* Draggable/Scrollable Container */}
        <div 
          ref={scrollRef}
          className="flex overflow-x-auto space-x-8 pb-12 hide-scrollbar snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {reviews.map((review, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.05 }}
              className="flex-shrink-0 w-[320px] md:w-[450px] glass p-10 rounded-[2.5rem] border-white/5 relative group hover:border-gold/20 transition-all snap-center"
            >
              <Quote className="text-gold/20 w-12 h-12 absolute top-8 right-8 group-hover:text-gold/40 transition-colors" />
              <div className="flex space-x-1 text-gold mb-6">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={12} fill="currentColor" />)}
              </div>
              <p className="text-white/70 font-light leading-relaxed mb-8 italic min-h-[120px]">
                "{review.text}"
              </p>
              <div className="pt-6 border-t border-white/5">
                <p className="font-bold text-sm tracking-widest uppercase mb-1">{review.author}</p>
                <p className="text-[10px] text-gold uppercase tracking-[0.2em]">{review.date}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Subtle indicator of scroll progress */}
        <div className="flex justify-center mt-4">
          <div className="h-1 w-32 bg-white/5 rounded-full relative overflow-hidden">
             <motion.div 
               className="absolute inset-0 bg-gold/30"
               initial={{ x: "-100%" }}
               whileInView={{ x: "0%" }}
               transition={{ duration: 1 }}
             />
          </div>
        </div>
      </div>
      
      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
};

export default Testimonials;
